import { useQuery } from '@tanstack/react-query'
import { getDocument, isDocumentsApiAvailable } from '@/services/documents/documentsApi'
import { isProcessing } from '@/services/documents/documentMappers'

export function useArtifactDocument(documentId) {
  return useQuery({
    queryKey: ['do-chat', 'artifact-document', documentId],
    queryFn: ({ signal }) => getDocument(documentId, { signal }),
    enabled: Boolean(documentId) && isDocumentsApiAvailable(),
    retry: false,
    refetchInterval: (query) => (isProcessing(query.state.data) ? 2500 : false),
  })
}
